export type FuelType =
  | 'diesel'
  | 'diesel_s10'
  | 'gasoline'
  | 'ethanol'
  | 'flex'
  | 'electric'
  | 'cng';

export type VehicleCategory = 'car' | 'van' | 'truck' | 'motorcycle' | 'machine' | 'other';

export interface Vehicle {
  id: string;
  plate: string;
  brand: string | null;
  model: string | null;
  year: number | null;
  color: string | null;
  renavam: string | null;
  chassi: string | null;
  fuelType: FuelType;
  category: VehicleCategory;
  tankCapacityMl: number | null;
  odometerMeters: number;
  hourmeterMinutes: number;
  tracksOdometer: boolean;
  tracksHourmeter: boolean;
  crlvNumber: string | null;
  crlvExpiresAt: string | null;
  anttRntrc: string | null;
  notes: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  version: number;
}

export interface VehiclesListResponse {
  data: Vehicle[];
  meta: { page: number; limit: number; total: number };
}

export const FUEL_TYPE_LABELS: Record<FuelType, string> = {
  diesel: 'Diesel comum',
  diesel_s10: 'Diesel S10',
  gasoline: 'Gasolina',
  ethanol: 'Etanol',
  flex: 'Flex',
  electric: 'Elétrico',
  cng: 'GNV',
};

export const VEHICLE_CATEGORY_LABELS: Record<VehicleCategory, string> = {
  car: 'Carro',
  van: 'Van / Utilitário',
  truck: 'Caminhão',
  motorcycle: 'Moto',
  machine: 'Máquina / Equipamento',
  other: 'Outro',
};
